import * as Mui from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import SectionHeader from "../../../../../util/component/SectionHeader";
import { ContextOperation } from "../../../context/OperationContext";
import { availabilityReportActions } from "../service/availabilityReport.actions";
import { IAvailabilityReport } from "../types/IAvailabilityReport";
import { FilterBox } from "./FilterBox";
import { SingleLocationTable } from "./SingleLocationTable";
import { TotalSingleLocationTable } from "./TotalSingleLocationTable";
import EmptyState from "../../../../../util/component/EmptyState";

type Props = {};

const AvailabilityReport = (props: Props) => {
  const { tenant, setLoading } = useContext(ContextOperation);
  const { t } = useTranslation(["operation"]);

  // FILTER DATA
  const [onlyCustomer, setOnlyCustomer] = useState(true);
  const [location, setLocation] = useState<any[]>([]);

  const [data, setdata] = useState<IAvailabilityReport>();

  useEffect(() => {}, []);

  const onClickProceed = () => {
    setLoading(true);
    if (location.length === 0) {
      setdata(undefined);
      setLoading(false);
    }

    const pickUpList = [];

    for (const loc of location) {
      if (loc.element.locationList?.length > 0) {
        for (const subLoc of loc.element.locationList) {
          pickUpList.push({
            displayName: subLoc.displayName,
            locationId: subLoc.id,
            locationType: subLoc.locationType,
          })
        }
        continue;
      }

      pickUpList.push({
        displayName: loc.element.displayName,
        locationId: loc.element.id,
        locationType: loc.element.locationType,
      });
    }

    availabilityReportActions()
      .getAvailabilityByGroup(tenant, {
        onlyCustomerAtDesk: onlyCustomer,
        pickUpList,
      })
      .then((response) => {
        setdata(response);
        setLoading(false);
      });
  };

  return (
    <>
      <SectionHeader title={t("availabilityReport.mainTitle")} />

      <Mui.Stack p={2} spacing={2}>
        <FilterBox
          location={location}
          onClickProceed={onClickProceed}
          onlyCustomer={onlyCustomer}
          setLocation={setLocation}
          setOnlyCustomer={setOnlyCustomer}
        />

        {!data && (
          <Mui.Box
            sx={{
              pt: {
                xs: 1,
                sm: 2,
                md: 4,
                lg: 8,
              },
            }}
          >
            <EmptyState
              title={t("availabilityReport.noLocationSelectedTitle")}
              content={t("availabilityReport.noLocationSelectedContent")}
            />
          </Mui.Box>
        )}

        {data?.totalRows && <TotalSingleLocationTable data={data.totalRows} />}

        {data?.singleLocationAvailabilityReportResponses.map((element) => (
          <SingleLocationTable data={element} />
        ))}
      </Mui.Stack>
    </>
  );
};

export default AvailabilityReport;
